const generalTrans = {
  en: {
    // STEP 1
    headlineStep1: 'Join Unisport',
    email: 'Enter e-mail',
    confirmConsentText: 'Please confirm your consent',
    ctaSignup: 'Sign up',
    shortPermissionText:
      'I agree to receiving personlised offers, promotions and discounts from Unisport through the channels I select, such as e-mail, sms or direct mail. I can always withdraw my consent.',
    consent: 'Read more about your consent',
    privacyPolicy: 'Read our privacy policy',
    fullConsentText: '',
    privacyTerms: '',
    consentLink: '',
    privacyLink: 'https://www.unisportstore.com/policies/privacy/',

    // STEP 2
    headlineStep2: 'I am interested in:',
    ctaUpdate: 'UPDATE',
    ctaNext: 'Continue',

    // STEP 3
    headlineStep3: 'Thanks for signing up!',

    // Errors
    error1: 'Please enter a valid e-mail address',
    error2: 'An error occured. Please try again.',
    error3: 'Please enter a valid e-mail address.',
    error4: 'A user with this email address already exists.',
    error5:
      'We are sorry, we are unable to complete your sign-up right now. Please try again.',
    error6: 'Sorry. You are already subscribed with this email address.',
    error7: 'This field is required.'
  },

  da: {
    // STEP 1
    headlineStep1: 'Bliv en del af Unisport',
    email: 'Indtast e-mail',
    confirmConsentText: 'Bekræft venligst dit samtykke',
    ctaSignup: 'Tilmeld',
    shortPermissionText:
      'Ja tak, jeg vil gerne modtage gode og personaliserede tilbud på nyheder og konkurrencer fra Unisport og accepterer betingelserne.',
    consent: 'Læs betingelser.',
    privacyPolicy: 'Se privatlivsvilkår.',
    fullConsentText: '',
    privacyTerms: '',
    consentLink: '',
    privacyLink: 'https://www.unisport.dk/policies/privacy/',

    // STEP 2
    headlineStep2: 'Jeg interesserer mig for:',
    ctaUpdate: 'OPDATER',
    ctaNext: 'Fortsæt',

    // STEP 3
    headlineStep3: 'Tak fordi du tilmeldte dig!',
    altHeadline: 'Næsten færdig',
    subHeadline: 'Du er nu tilmeldt',
    altSubHeadline:
      'Vi sender dig en e-mail med et link, så du kan aktivere dit abonnement. Tjek dit spamfilter, hvis du ikke kan se den i din indbakke.',
    confirmation1:
      'Nu hvor du er på vores liste, vil vi holde dig opdateret med nyheder, inspiration og eksklusive tilbud.',
    confirmation2:
      'Du kan altid ændre hvordan du modtager information fra os og tilmelde dig som medlem af vores fordelsklub Unisport FC på unisport.dk/login.',

    // Errors
    error1: 'Skriv venligst din e-mail adresse igen',
    error2: 'Der er sket en fejl. Prøv venligst igen.',
    error3: 'Indtast venligst en valid e-mail adresse.',
    error4: 'En bruger med denne e-mail adresse findes allerede.',
    error5:
      'Vi kan desværre ikke gennemføre din tilmelding lige nu. Prøv venligst igen.',
    error6: 'Vi beklager. Du er allerede tilmeldt med denne e-mail adresse.',
    error7: 'Dette felt er obligatorisk.'
  },

  sv: {
    // STEP 1
    headlineStep1: 'Bli en del av Unisport',
    email: 'Skriv in din mejladress',
    confirmConsentText: 'Vänligen bekräfta ditt godkännande',
    ctaSignup: 'Registrera',
    shortPermissionText:
      'Ja tack, jag vill gärna ta emot bra och personaliserade erbjudanden från Unisport via de kanaler jag väljer, exempelvis e-post, brev eller sms. Jag kan ångra mitt godkännande när som helst.',
    consent: 'Läs mer om ditt godkännande',
    privacyPolicy: 'Läs vår sekretesspolicy',
    fullConsentText: '',
    privacyTerms: '',
    consentLink: '',
    privacyLink: 'https://www.unisportstore.se/policies/privacy/',

    // STEP 2
    headlineStep2: 'Jag är intresserad av:',
    ctaUpdate: 'UPPDATERA',
    ctaNext: 'Fortsätt',

    // STEP 3
    headlineStep3: 'Tack för att du registrerade dig!',
    altHeadline: 'Nästan klar',
    subHeadline: 'Du är nu registrerad',
    altSubHeadline:
      'Vi skickar ett mejl till dig innehållande en länk som du ska använda för att aktivera din prenumeration. Kolla din skräppost om det inte dyker upp i inkorgen',
    confirmation1:
      'Nu när du prenumererar på vårt nyhetsbrev håller vi dig uppdaterad med de senaste nyheterna, inspiration och exklusiva fotbollserbjudanden.',
    confirmation2:
      'Du kan alltid ändra hur du får information från oss och registrera dig som medlem i vår förmånsklubb Unisport FC på unisportstore.se/login.',

    // Errors
    error1: 'Vänligen bekräfta din mejladress',
    error2: 'Ett fel har inträffat. Prova igen.',
    error3: 'Skriv in en giltig mejladress',
    error4: 'Det finns redan en användare registrerad med denna mejladressen.',
    error5:
      'Vi kan tyvärr inte genomföra din registrering just nu. Vänligen prova igen.',
    error6: 'Du är redan registrerad med denna mejladress.',
    error7: 'Detta fält är obligatoriskt.'
  },

  nb: {
    // STEP 1
    headlineStep1: 'Bli en del av Unisport',
    email: 'Skriv inn e-posten din',
    confirmConsentText: 'Vennligst bekreft godkjennelsen din',
    ctaSignup: 'Registrer',
    shortPermissionText:
      'Ja takk, jeg vil gjerne motta gode og personaliserte tilbud fra Unisport via de kanalene jeg velger. F.eks. e-post, brev eller SMS. Jeg kan angre på min godkjennelse når som helst.',
    consent: 'Les mer om godkjennelsen din',
    privacyPolicy: 'Les vårt personvern',
    fullConsentText: '',
    privacyTerms: '',
    consentLink: '',
    privacyLink: 'https://www.unisportstore.no/policies/privacy/',

    // STEP 2
    headlineStep2: 'Jeg er interessert i:',
    ctaUpdate: 'OPPDATER',
    ctaNext: 'Fortsett',

    // STEP 3
    headlineStep3: 'Takk for at du registrerte deg!',
    altHeadline: 'Nesten ferdig',
    subHeadline: 'Du er nå registrert',
    altSubHeadline:
      'Vi sender deg en e-post med en link for å aktivere abonnementet ditt. Sjekk spam/søppelpost hvis den ikke kommer i innboksen din.',
    confirmation1:
      'Nå når du er på listen holder vi deg oppdatert på de nyeste lanseringene, inspirasjon og eksklusive tilbud.',
    confirmation2:
      'Du kan når som helst endre på hvordan du mottar informasjon fra oss og registrere deg som medlem av vår fordelsklubb Unisport FC på unisportstore.no/login.',

    // Errors
    error1: 'Vennligst skriv e-posten din igjen',
    error2: 'Det har skjedd en feil, vennligst prøv igjen.',
    error3: 'Skriv en gyldig mailadresse.',
    error4: 'Det finnes allerede en bruker med denne mailadressen.',
    error5:
      'Vi kan dessverre ikke gjennomføre registreringen din akkurat nå. Vennligst prøv igjen.',
    error6: 'Vi beklager. Du er allerede registrert med denne mailadressen.',
    error7: 'Dette feltet er obligatorisk. '
  },

  fi: {
    // STEP 1
    headlineStep1: 'Liity Unisportiin',
    email: 'Aseta sähköpostiosoite',
    confirmConsentText: 'Ole hyvä ja vahvista suostumus',
    ctaSignup: 'Ilmoittaudu',
    shortPermissionText:
      'Hyväksyn, että vastaanotan henkilökohtaisia tarjouksia, mainoksia ja alennuksia Unisportilta kanavista, jotka valitsen, kuten sähköposti, tekstiviestit tai kirjeet. Voin aina peruuttaa suostumukseni.',
    consent: 'Lue lisää suostumuksestasi',
    privacyPolicy: 'Lue yksityisyyden suojastamme',
    fullConsentText: '',
    privacyTerms: '',
    consentLink: '',
    privacyLink: 'https://www.unisportstore.fi/policies/privacy/',

    // STEP 2
    headlineStep2: 'Minua kiinnostaa:',
    ctaUpdate: 'PÄIVITÄ',
    ctaNext: 'Jatka',

    // STEP 3
    headlineStep3: 'Kiitos ilmoittautumisesta!',
    altHeadline: 'Melkein valmista',
    subHeadline: 'Olet nyt rekisteröitynyt',
    altSubHeadline:
      'Tulemme lähettämään sinulle sähköpostin, joka sisältää linkin uutiskirjeen tilauksen aktivointiin. Katso roskapostikansio, jos viestiä ei näy postilaatikossa.',
    confirmation1:
      'Nyt kun olet sähköpostilistallamme, niin tulemme pitämään sinut ajantasalla uusimmista tuotteista, inspiraation lähteistä ja jalkapallotuotteiden tarjouksista.',
    confirmation2:
      'Voit vaihtaa profiilisi asetuksia ja tulla jäseneksi Unisportin etukerhoon osoitteessa unisportstore.fi/login.',

    // Errors
    error1: 'Aseta voimassaoleva sähköpostiosoite',
    error2: 'Tapahtui virhe. Ole hyvä ja yritä uudelleen.',
    error3: 'Ole hyvä ja aseta voimassaoleva sähköpostiosoite.',
    error4: 'Tällä sähköpostiosoitteella on jo rekisteröitynyt käyttäjä.',
    error5:
      'Olemme pahoillamme, emme pysty viimeistelemään ilmoittautumistasi juuri nyt. Ole hyvä ja yritä uudelleen.',
    error6:
      'Pahoittelemme. Olet jo ilmoittautunut tällä sähköpostiosoitteella.',
    error7: 'Tämä kenttä on pakollinen.'
  },

  nl: {
    // STEP 1
    headlineStep1: 'Sluit je aan bij Unisport',
    email: 'E-mail invoeren',
    confirmConsentText: 'Bevestig alsjeblieft je toestemming',
    ctaSignup: 'Inschrijven',
    shortPermissionText:
      'Ik ga akkoord met het ontvangen van persoonlijke aanbiedingen, promoties en kortingen van Unisport via de kanalen die ik selecteer, zoals per e-mail, sms of post. Ik kan altijd mijn toestemming intrekken.',
    consent: 'Lees meer over je toestemming',
    privacyPolicy: 'Lees ons privacy beleid',
    fullConsentText: '',
    privacyTerms: '',
    consentLink: '',
    privacyLink: 'https://www.unisportstore.nl/policies/privacy/',

    // STEP 2
    headlineStep2: 'Ik ben geïnteresseerd in:',
    ctaUpdate: 'UPDATEN',
    ctaNext: 'Ga verder',

    // STEP 3
    headlineStep3: 'Bedankt voor het aanmelden!',
    altHeadline: 'Bijna klaar',
    subHeadline: 'Je bent nu aangemeld',
    altSubHeadline:
      'We sturen je een e-mail met een link om je aanmelding te af te ronden. Controleer ook even je spambox indien je niets ontvangt.',
    confirmation1:
      'Nu je je hebt ingeschreven houden wij je op de hoogte van de nieuwste releases, inspiraties en exclusieve deals.',
    confirmation2:
      'Je kan altijd je profiel instellingen aanpassen en lid worden van de Unisport FC voordeelclub via unisportstore.nl/login.',

    // Errors
    error1: 'Voer alsjeblieft een geldig e-mailadres in',
    error2: 'Er is iets misgegaan. Probeer het nog eens.',
    error3: 'Voer alsjeblieft een geldig e-mailadres in.',
    error4: 'Er bestaat al een gebruiker met dit e-mailadres.',
    error5:
      'Sorry, het is momenteel niet mogelijk om je inschrijving af te ronden. Probeer het alsjeblieft nog eens.',
    error6: 'Sorry. Je bent al ingeschreven met dit e-mailadres.',
    error7: 'Dit veld is verplicht.'
  },

  fr: {
    // STEP 1
    headlineStep1: 'Rejoignez Unisport',
    email: 'Entrez votre email',
    confirmConsentText: 'Veuillez confirmer votre accord',
    ctaSignup: 'Inscription',
    shortPermissionText:
      'J´accepte de recevoir des offres personnalisées, promotions et réductions de la part d´Unisport au travers des chaînes que je sélectionne, email, sms, courrier. Je peux toujours retirer mon consentement.',
    consent: 'Lire plus sur votre accord',
    privacyPolicy: 'Veuillez confirmer votre accord',
    fullConsentText: '',
    privacyTerms: '',
    consentLink: '',
    privacyLink: 'https://www.unisportstore.fr/policies/privacy/',

    // STEP 2
    headlineStep2: 'Je suis intéressé par:',
    ctaUpdate: 'METTRE À JOUR',
    ctaNext: 'Continuer',

    // STEP 3
    headlineStep3: 'Merci pour votre inscription!',
    altHeadline: 'Presque terminé',
    subHeadline: 'Vous êtes maintenant inscrit',
    altSubHeadline:
      "Nous t'enverrons un email avec un lien pour valider ton inscription. Vérifie tes courriers indésirables et spam si tu n'as rien reçu.",
    confirmation1:
      'Maintenant que vous êtes inscrit nous vous tiendrons au courant de toutes les nouveautés et offres spéciales.',
    confirmation2:
      'Vous pouvez modifier votre profil et vos préférences pour devenir membre du club Unisport FC en allant sur unisportstore.com/login.',

    // Errors
    error1: 'Veuillez entrer une adresse email valide',
    error2: 'Une erreur est apparue. Veuillez réessayer',
    error3: 'Veuillez entrer une adresse email valide',
    error4: 'Un utilisateur avec cette adresse existe déjà.',
    error5:
      'Nous sommes désolés, votre inscription ne peut pas être complétée maintenant. Veuillez réessayer',
    error6: 'Désolé. Vous êtes déjà inscrit avec cette adresse email.',
    error7: 'Ce champs est requis.'
  },

  de: {
    // STEP 1
    headlineStep1: 'Werde ein Teil von Unisport',
    email: 'Email eingeben',
    confirmConsentText: 'Bitte bestätige deine Einwilligung',
    ctaSignup: 'Anmelden',
    shortPermissionText:
      'Ich stimme zu, persönliche Angebote, Werbung und Rabatte von Unisport über den Kanal zu erhalten, welchen ich ausgewählt habe. Ich kann meine Einwilligung jederzeit widerrufen.',
    consent: 'Lese mehr über deine Einwilligung',
    privacyPolicy: 'Lese unsere Datenschutzbestimmungen',
    fullConsentText: '',
    privacyTerms: '',
    consentLink: '',
    privacyLink: 'https://www.unisportstore.de/policies/privacy/',

    // STEP 2
    headlineStep2: 'Ich interessiere mich für:',
    ctaUpdate: 'Aktualisieren',
    ctaNext: 'Fortsetzen',

    // STEP 3
    headlineStep3: 'Danke für deine Anmeldung!',
    altHeadline: 'Fast geschafft',
    subHeadline: 'Du bist jetzt angemeldet',
    altSubHeadline:
      'Wir werden dir eine E-Mail schicken, die einen Link enthält, mit dem du deine Anmeldung bestätigen kannst. Ûberprüfen deinen Spam/Junk Ordner, falls sie nicht im Posteingang ist.',
    confirmation1:
      'Jetzt wo du für unseren Newsletter angemeldet bist werden wir dich regelmäßig über neue Veröffentlichungen, Neuheiten und exklusive Fußball-Angebote informieren.',
    confirmation2:
      'Du kannst deine Profil-Einstellungen anpassen und auf unisportstore.com/login ein Mitglied des Unisport-Clubs werden.',

    // Errors
    error1: 'Bitte gebe eine gültige Email ein',
    error2: 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    error3: 'Bitte gebe eine gültige Email ein.',
    error4: 'Es exisitert bereits ein Benutzer mit dieser Email.',
    error5:
      'Bitte entschuldige, wir können deine Anmeldung zurzeit nicht abschließen. Bitte versuche es später erneut.',
    error6: 'Du bist bereits mit dieser Email angemeldet.',
    error7: 'Dieses Feld ist erforderlich.'
  },

  at: {
    // STEP 1
    headlineStep1: 'Werde ein Teil von Unisport',
    email: 'Email eingeben',
    confirmConsentText: 'Bitte bestätige deine Einwilligung',
    ctaSignup: 'Anmelden',
    shortPermissionText:
      'Ich stimme zu, persönliche Angebote, Werbung und Rabatte von Unisport über den Kanal zu erhalten, welchen ich ausgewählt habe. Ich kann meine Einwilligung jederzeit widerrufen.',
    consent: 'Lese mehr über deine Einwilligung',
    privacyPolicy: 'Lese unsere Datenschutzbestimmungen',
    fullConsentText: '',
    privacyTerms: '',
    consentLink: '',
    privacyLink: 'https://www.unisportstore.de/policies/privacy/',

    // STEP 2
    headlineStep2: 'Ich interessiere mich für:',
    ctaUpdate: 'Aktualisieren',
    ctaNext: 'Fortsetzen',

    // STEP 3
    headlineStep3: 'Danke für deine Anmeldung!',
    altHeadline: 'Fast geschafft',
    subHeadline: 'Du bist jetzt angemeldet',
    altSubHeadline:
      'Wir werden dir eine E-Mail schicken, die einen Link enthält, mit dem du deine Anmeldung bestätigen kannst. Ûberprüfen deinen Spam/Junk Ordner, falls sie nicht im Posteingang ist.',
    confirmation1:
      'Jetzt wo du für unseren Newsletter angemeldet bist werden wir dich regelmäßig über neue Veröffentlichungen, Neuheiten und exklusive Fußball-Angebote informieren.',
    confirmation2:
      'Du kannst deine Profil-Einstellungen anpassen und auf unisportstore.com/login ein Mitglied des Unisport-Clubs werden.',

    // Errors
    error1: 'Bitte gebe eine gültige Email ein',
    error2: 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.',
    error3: 'Bitte gebe eine gültige Email ein.',
    error4: 'Es exisitert bereits ein Benutzer mit dieser Email.',
    error5:
      'Bitte entschuldige, wir können deine Anmeldung zurzeit nicht abschließen. Bitte versuche es später erneut.',
    error6: 'Du bist bereits mit dieser Email angemeldet.',
    error7: 'Dieses Feld ist erforderlich.'
  }
};

const categoryTrans = {
  da: {
    category: 'Hvilke produkter er du interesseret i?',
    category_id: '6b00a7abee',
    boot: 'Fodboldstøvler',
    boot_id: '213e750cda',
    shirt: 'Fodboldtrøjer',
    shirt_id: '3dbaaad8ba',
    goalkeeper: 'Målmandsprodukter',
    goalkeeper_id: 'a9ea007912',
    kids: 'Fodboldprodukter til børn',
    kids_id: '7eb4e85bd8'
  },

  sv: {
    category: 'Vilka produkter är du intresserad av?',
    category_id: '9846122641',
    boot: 'Fotbollsskor',
    boot_id: '404f2e0054',
    shirt: 'Fotbollströjor',
    shirt_id: '20aca22894',
    goalkeeper: 'Målvaktsprodukter',
    goalkeeper_id: '48393fbe5f',
    kids: 'Fotbollsprodukter för barn',
    kids_id: '0db5d23028'
  },

  nb: {
    category: 'Hvilke produkter er du interessert i?',
    category_id: 'c69f8a888f',
    boot: 'Fotballsko',
    boot_id: 'b0fd5bd6a7',
    shirt: 'Fotballdrakter',
    shirt_id: '905c107010',
    goalkeeper: 'Keeperprodukter',
    goalkeeper_id: '348df1762f',
    kids: 'Fotballprodukter til barn',
    kids_id: '983702293c'
  },

  en: {
    category: 'What products are you interested in?',
    category_id: '26c2ec431b',
    boot: 'Football boots',
    boot_id: 'f19f1c76b0',
    shirt: 'Football shirts',
    shirt_id: '2b768ac8d3',
    goalkeeper: 'Goalkeeper products',
    goalkeeper_id: '6fde755e2d',
    kids: 'Kids football products',
    kids_id: '260af78fe4'
  },

  fi: {
    category: 'Mistä tuotteista olet kiinnostunut?',
    category_id: '624b3324cb',
    boot: 'Jalkapallokengät',
    boot_id: 'c4338deb2e',
    shirt: 'Pelipaidat',
    shirt_id: '241bbe5e24',
    goalkeeper: 'Maalivahdin tarvikkeet',
    goalkeeper_id: '47f35e9951',
    kids: 'Lasten jalkapallotuotteet',
    kids_id: '444ee0b6f7'
  },

  nl: {
    category: 'Welke producten interesseren jou het meest?',
    category_id: '9868254aa1',
    boot: 'Voetbalschoenen',
    boot_id: 'ab48576c6d',
    shirt: 'Voetbalshirts',
    shirt_id: '451de36af9',
    goalkeeper: 'Keepersuitrusting',
    goalkeeper_id: '85a28d411e',
    kids: 'Producten voor kinderen',
    kids_id: '55d9c0af6c'
  },

  de: {
    category: 'Für welche Produkte interessierst du dich?',
    category_id: '0e70128757',
    boot: 'Fussballschuhe',
    boot_id: 'b69849fd42',
    shirt: 'Fussballtrikots',
    shirt_id: '3e2339abbc',
    goalkeeper: 'Torwartausruestung',
    goalkeeper_id: 'db6ab8ba3d',
    kids: 'Kinder Fussballprodukte',
    kids_id: 'e899ccc2c7'
  },

  fr: {
    category: 'Quels articles vous intéressent?',
    category_id: '388e8e7dbe',
    boot: 'Chaussures de foot',
    boot_id: 'f163ef8c80',
    shirt: 'Maillots de foot',
    shirt_id: 'e3f5137643',
    goalkeeper: 'Equipement de gardien',
    goalkeeper_id: '8dadc8d3d5',
    kids: 'Articles pour enfant',
    kids_id: '01fcbb92fc'
  },

  at: {
    category: 'Für welche Produkte interessierst du dich?',
    category_id: 'd47fa8d25a',
    boot: 'Fussballschuhe',
    boot_id: '91de5ef377',
    shirt: 'Fussballtrikots',
    shirt_id: 'c03f434854',
    goalkeeper: 'Torwartausruestung',
    goalkeeper_id: 'cfe880a7f0',
    kids: 'Kinder Fussballprodukte',
    kids_id: 'a1b1faaa66'
  }
};

export default function setLanguage(type, language) {
  let translation;
  if (language === 'de-AT') {
    translation = type === 'general' ? generalTrans.at : categoryTrans.at;
  } else if (language === 'pl') {
    translation = type === 'general' ? generalTrans.en : categoryTrans.en;
  } else {
    translation =
      type === 'general' ? generalTrans[language] : categoryTrans[language];
  }
  return translation;
}
